import { render } from "./PendingWithdrawalsForm.vue?vue&type=template&id=ac18c6d6&ts=true"
import script from "./PendingWithdrawalsForm.vue?vue&type=script&lang=ts"
export * from "./PendingWithdrawalsForm.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__